import { AlmeResponseNext } from '@alme/types/response/AlmeResponse';
import { AlmeLaunchIvaMessageEventData } from '@alme/post-message-api/AlmeLaunchIvaMessageEventData';
import { isMobile, isTablet } from 'react-device-detect';
import { ChannelTypes } from '@alme/api-ts/Alme/V5/ChannelTypes';

export interface AlmeSavedAppState {
    isOpen?: boolean;
    lastEntryId?: string;
    isMinimized?: boolean;
}

// TODO: Split out unrelated properties from AlmeAppState for better rendering performance.
export interface AlmeAppState extends AlmeSavedAppState {
    history: (AlmeResponseNext)[];
    launchQuestion?: string;
    isDialogOpen?: boolean;
    liveChatIndex: number;
    isLiveChatConnected: boolean;
    launchData?: AlmeLaunchIvaMessageEventData;
    agentChannel: ChannelTypes;
}

export function createChannelTypes(): ChannelTypes {
    if (isMobile || isTablet) {
        return "MobileWeb";
    }
    return "Web";
}
